import React, { useCallback, useEffect, useState } from 'react'
import { Form, Modal, Input, Row, Button, Col, Select, Checkbox, Divider, message } from 'antd'
import CategorySelect from '@components/CategorySelect'
import AsyncAttributeItemSelect from './AsyncAttributeItemSelect'
import { findAttributes, getAttributeById, createOrUpdateCatgoryAttribute, getCategoryAttributeById } from '@services/attributeService'
import { showError } from '@utils/alert'
import Loading from '@components/loading'

const { confirm } = Modal

const INPUT_TYPES = [{
  label: '多选',
  value: 0,
}, {
  label: '单选',
  value: 1,
}]

function CategoryAttributeMappingEdit (props: any) {
  const { categoryItem, visible, onCancel } = props
  const [form] = Form.useForm()
  const [item, setItem] = useState<any>(null)
  const [categoryId, setCategoryId] = useState<any>(null)
  const [values, setValues] = useState<any>(null)
  const [valueLoading, setValueLoading] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)

  const searchAttrValues = useCallback((id: string | null) => {
    if (!id) return
    setValueLoading(true)
    findAttributes(id, 0, 1000)
      .then(r => {
        if (r.data) {
          if (Array.isArray(r.data.items)) {
            setValues(r.data.items)
            if (!form.getFieldValue('values') || !form.getFieldValue('values').length) {
              form.setFieldsValue({
                values: r.data.items?.filter(v => v.valid)?.map((v: any) => v.id) || []
              })
            }
          }
        }
        setValueLoading(false)
      })
      .catch(e => {
        setValueLoading(false)
        console.error(e)
      })
  }, [form])

  const updateCategoryAttrItem = useCallback((categoryItem: any, categoryId: string, item: any) => {
    const categoryAttrItems = categoryItem?.attr_set?.items?.length ? [...categoryItem.attr_set.items] : []
    const updateItemIndex = categoryAttrItems.findIndex(attr => attr.id === item.id)
    if (updateItemIndex > -1) {
      categoryAttrItems[updateItemIndex] = item
    } else {
      categoryAttrItems.push(item)
    }
    const hide = message.loading('保存中...')
    createOrUpdateCatgoryAttribute(categoryId, {
      attr_set: {
        items: categoryAttrItems,
      }
    })
    .then(res => {
      hide()
      setConfirmLoading(false)
      message.success(`更新分类:${categoryId} 跟属性项:${item.id} 关联成功`)
      onCancel && onCancel()
    })
    .catch(e => {
      hide()
      setConfirmLoading(false)
      console.error(e)
      showError(e)
    })
  }, [onCancel])

  const showUpdateConfirmModal = useCallback((categoryItem: any, categoryId: string, item: any) => {
    confirm({
      title: '更新',
      content: `分类 ${categoryId} 已关联相同属性项 ${item.id}, 确认覆盖吗?`,
      okText: '确认',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        updateCategoryAttrItem(categoryItem, categoryId, item)
      },
      onCancel() {
        setConfirmLoading(false)
      },
    })
  }, [updateCategoryAttrItem])

  const onEditMapping = () => {
    form.validateFields().then(formValue => {
      if (!item) {
        message.error('必须选择属性项')
        return
      }
      if (!categoryId) {
        message.error('必须选择分类 id')
        return
      }
      const updateItem = {
        id: item.id,
        value: item.value,
        type: 1, // item type
        valid: item.valid,
        input: formValue.input,
        display_name: formValue.display_name,
        created_at: item.created_at,
        last_modified_at: item.last_modified_at,
        childrens: values?.filter(v => formValue.values?.indexOf(v.id) !== -1) || []
      }
      setConfirmLoading(true)
      getCategoryAttributeById(categoryId)
        .then(res => {
          if (res.data?.attr_set?.items?.length) {
            const existingItem = res.data.attr_set.items.find(attrItem => attrItem.id === item.id)
            if (!existingItem) {
              updateCategoryAttrItem(res.data, categoryId, updateItem)
              return
            }
            // 提示更新
            showUpdateConfirmModal(res.data, categoryId, updateItem)
          } else {
            updateCategoryAttrItem(res.data, categoryId, updateItem)
          }
        })
        .catch(e => {
          setConfirmLoading(false)
          console.error(e)
        })
    })
    .catch(e => {
      console.error(e)
      showError('from valid failed', e)
    })
  }

  useEffect(() => {
    setValues([])
    setItem(null)
    setCategoryId(categoryItem?.category_id)
    if (categoryItem?.origin?.id) {
      getAttributeById(categoryItem?.origin?.id)
        .then(res => {
          setItem(res.data)
          searchAttrValues(res.data.id)
        })
        .catch(e => {
          console.error(e)
        })
    }
    form.resetFields()
    const initialValue: any = {
      display_name: categoryItem?.origin?.display_name,
      input: categoryItem?.origin?.input,
      values: categoryItem?.origin?.childrens?.map(v => v.id) || [],
    }
    form.setFieldsValue(initialValue)
  }, [form, categoryItem, searchAttrValues])

  const onCheckAll = useCallback(() => {
    form.setFieldsValue({
      values: values?.filter(v => v.valid)?.map((v: any) => v.id) || []
    })
  }, [form, values])

  const onUnCheckAll = useCallback(() => {
    form.setFieldsValue({
      values: []
    })
  }, [form])

  const onChangeItem = useCallback((v) => {
    setItem(v)
    form.setFieldsValue({
      display_name: v?.display_name,
      input: INPUT_TYPES[0].value,
    })
    if (v?.id) {
      searchAttrValues(v.id)
    } else {
      setValues([])
    }
  }, [form, searchAttrValues])
  return (
    <Modal
      title={`${ categoryItem ? '编辑' : '新建' }分类属性关联`}
      centered
      width={600}
      closable
      visible={visible}
      onCancel={onCancel}
      maskClosable={false}
      confirmLoading={confirmLoading}
      footer={
        <>
          <Button onClick={onCancel} type="default">取消</Button>
          <Button onClick={onEditMapping} type="primary">保存</Button>
        </>
      }
    >
      <Form name="attr-item" form={form}>
        <Form.Item label="Category Id" required>
          <CategorySelect
            value={categoryId}
            leafOnly
            onChange={setCategoryId}
            placeholder="please select a category id"
          />
        </Form.Item>
        <Form.Item label="Attribute Item" required>
          {categoryItem?.origin ? <Input readOnly value={categoryItem?.origin?.value} /> : (
            <AsyncAttributeItemSelect
              value={item?.id}
              onChange={onChangeItem}
              placeholder="please search a attribute item"
            />
          )}
        </Form.Item>
        <Form.Item name="display_name" label="Display Name" shouldUpdate={(prev, next) => prev.display_name !== next.display_name}>
          <Select placeholder="please select a display name">
            {item?.alias ? item.alias.map(a => {
              return <Select.Option key={a} value={a}>{a}</Select.Option>
            }) : null}
          </Select>
        </Form.Item>
        <Form.Item name="input" label="Input Type" initialValue={INPUT_TYPES[0].value} required>
          <Select>
            {INPUT_TYPES.map(input => (<Select.Option key={input.value} value={input.value}>{input.label}</Select.Option>))}
          </Select>
        </Form.Item>
        <Form.Item name="values" label="Attribute Values" required>
          <Checkbox.Group style={{ width: '100%' }}>
            <div style={{ marginTop: 4 }}>
              <Button style={{ marginRight: 10 }} size="small" type="primary" onClick={onCheckAll}>全选</Button>
              <Button size="small" onClick={onUnCheckAll}>清空</Button>
            </div>
            <Divider />
            {valueLoading ? <Loading spinning /> : null}
            <Row>
              {values ? values.map((value: any) => {
                return (
                  <Col span={5} key={value.id}>
                    <Checkbox value={value.id} disabled={!value.valid}>
                      {value.value}
                    </Checkbox>
                  </Col>
                )
              }) : null}
            </Row>
          </Checkbox.Group>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CategoryAttributeMappingEdit
